import { Button, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './MarkReimbursedModal.module.scss';
import { Props } from './MarkReimbursedModal.types';

const MarkReimbursedModal = ({ open, onClose, count, totalAmount, loading, onConfirm }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={t('expenses.markReimbursed.modalTitle', 'Marquer comme remboursé')}
    >
      <Text size="sm" c="dimmed" mb="md">
        {t('expenses.markReimbursed.modalDescription', {
          defaultValue_one:
            'Vous allez marquer {{count}} dépense comme remboursée, pour un total de {{total}}€. Une dépense remboursée ne peut plus être modifiée ni supprimée.',
          defaultValue_other:
            'Vous allez marquer {{count}} dépenses comme remboursées, pour un total de {{total}}€. Une dépense remboursée ne peut plus être modifiée ni supprimée.',
          count,
          total: totalAmount.toFixed(2),
        })}
      </Text>
      <Text size="sm" c="dimmed" mb="md">
        {t(
          'expenses.markReimbursed.modalTransfersExplanation',
          'Vous pouvez aussi enregistrer automatiquement les remboursements correspondants : un transfert d’argent de chaque participant vers le payeur sera créé dans les opérations.'
        )}
      </Text>

      <div className={styles.buttons}>
        <Button variant="outline" onClick={onClose} disabled={loading}>
          {t('common.cancel', 'Annuler')}
        </Button>
        <Button variant="light" onClick={() => onConfirm(false)} loading={loading}>
          {t('expenses.markReimbursed.withoutTransfers', 'Marquer sans remboursement')}
        </Button>
        <Button onClick={() => onConfirm(true)} loading={loading}>
          {t('expenses.markReimbursed.withTransfers', 'Marquer et créer les remboursements')}
        </Button>
      </div>
    </Modal>
  );
};

export default MarkReimbursedModal;
